import React, { useMemo } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { trpc } from '../core/trpc'

type Props = {
  leadOwnerId: string
  onChange: (leadOwnerId: string) => void
}

const TypedAutocompleteComponent = Autocomplete<{ id: string; name: string }>

const LeadOwnerAutoCompleteField = ({ leadOwnerId, onChange }: Props) => {
  const getSubsidiaryListQuery = trpc.subsidiary.getSubsidiaryList.useQuery()
  const options = useMemo(() => {
    return (getSubsidiaryListQuery.data || []).map((sub) => ({ name: sub.name, id: sub.id }))
  }, [getSubsidiaryListQuery.data])

  return (
    <TypedAutocompleteComponent
      getOptionLabel={(option) => option.name}
      value={options.find((subsidiary) => subsidiary.id === leadOwnerId) ?? null}
      onChange={(_event, newValue) => {
        if (newValue === null) {
          onChange('')
          return
        }

        onChange(newValue.id)
      }}
      filterOptions={(options, params) => {
        const { inputValue } = params
        if (inputValue) {
          return options.filter((option) => option.name.toLowerCase().includes(inputValue.toLowerCase()))
        }

        return options
      }}
      options={options}
      renderInput={(params) => <TextField {...params} />}
    />
  )
}

export default LeadOwnerAutoCompleteField
